export default __webpack_public_path__ + "static/media/Minicard_3c.d3d6d7b0.svg";